import { axiosPrivate } from "./axios";

/**
 * Notification Center API – list, mark as read, unread count
 */

export const notificationService = {
  getNotifications: async (params = {}) => {
    const searchParams = new URLSearchParams();
    if (params.page != null) searchParams.set("page", params.page);
    if (params.limit != null) searchParams.set("limit", params.limit);
    if (params.unreadOnly === true) searchParams.set("unreadOnly", "true");
    const url = `/api/notifications${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;
    const response = await axiosPrivate.get(url);
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axiosPrivate.get("/api/notifications/unread-count");
    return response.data;
  },

  markAsRead: async (id) => {
    const response = await axiosPrivate.patch(`/api/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axiosPrivate.post(
      "/api/notifications/mark-all-read",
    );
    return response.data;
  },

  deleteNotification: async (id) => {
    const response = await axiosPrivate.delete(`/api/notifications/${id}`);
    return response.data;
  },

  deleteAllNotifications: async () => {
    const response = await axiosPrivate.delete("/api/notifications");
    return response.data;
  },
};
